import wrapError from "@/components/helpers/wrapError"

export const apiUpdateCustomer = (customerId, params, success, error) => {
  $.ajax({
    type: "PUT",
    url: `/api/admin/customers/${customerId}`,
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify(params),
    success,
    error: wrapError(error, "apiUpdateCustomer"),
  })
}

export const apiUpdateCustomerAvatar = (params, success, error) => {
  $.ajax({
    url: "/api/admin/customerAvatar",
    type: "PUT",
    dataType: "JSON",
    data: params,
    success,
    error: wrapError(error, "updateAvatar"),
  })
}

export const apiDeleteAdImage = (params, success, error) => {
  $.ajax({
    url: "/api/admin/customerAvatar",
    type: "DELETE",
    dataType: "JSON",
    data: params,
    success,
    error: wrapError(error, "deleteAdImage"),
  })
}
